module.exports = __webpack_public_path__ + "static/media/img2.851def42.png";